import { useSession, type Role } from '@/stores/session';

/** Roles allowed to create/edit projects + milestones (mirrors the backend
 * PROJECT_WRITE_ROLES). Plain Employees can view + log time, not author. */
const PROJECT_WRITE_ROLES: Role[] = ['super_admin', 'founder', 'sales_manager'];

/** Roles allowed to create projects + configure them (states/labels/types/
 * settings) — mirrors backend admin gating (ADR-071). A per-Member
 * `create_project` grant also exists server-side; this UI gate is UX only (F2). */
const PROJECT_ADMIN_ROLES: Role[] = ['super_admin', 'founder'];

export function useCanManageProjects(): boolean {
  const role = useSession((s) => s.role);
  return !!role && PROJECT_WRITE_ROLES.includes(role);
}

/** Create a project / edit project config (admin-gated, ADR-071). */
export function useCanAdminProjects(): boolean {
  const role = useSession((s) => s.role);
  return !!role && PROJECT_ADMIN_ROLES.includes(role);
}
